import billingApi from '@/lib/billingApi'

export type PackageMaximumKind = 'monthly_cap' | 'estimated_maximum' | 'uncapped' | 'unavailable'

export interface PackageSummary {
  server_uuid: string
  as_of: string
  state: string
  reason: string
  exact_deadline: string | null
  capabilities: Record<string, boolean>
  package: {
    display_name: string
    currency: string
    pricing: { minimum_minor: number; ceiling_minor: number; hourly_minor_numerator: number; hourly_denominator: number }
    limits: { cpu_millicores: number; memory_bytes: number; storage_bytes: number; backup_bytes: number; transfer_bytes: number }
  }
  billing: {
    period: { start: string; end: string }
    verified_runtime_microseconds: number
    accrued_usage_minor: number
    current_spend_minor: number | null
    projected_final_minor: number | null
    effective_floor_minor: number
    effective_cap_minor: number | null
    maximum_kind: PackageMaximumKind
    evidence_complete: boolean
    completeness: string
    coverage_gap_count: number
    known_coverage_microseconds?: number
    unavailable_coverage_microseconds?: number
    pending_coverage_microseconds?: number
    usage_as_of?: string | null
    spend_basis?: 'contract_bound' | 'verified_runtime' | null
    source_sequence_conflict?: boolean
    projection_assumption?: string | null
    credits: { status: string; amount_minor: number | null }
    tax: { status: string; amount_minor: number | null }
    collected_cash: { status: string; amount_minor: number | null }
  }
}

export interface PackageSummariesResponse {
  as_of: string
  summaries: Record<string, PackageSummary>
  unavailable_server_uuids: string[]
}

export async function getPackageSummaries(): Promise<PackageSummariesResponse> {
  const response = await billingApi.get<{ data: PackageSummariesResponse }>('/subscription/package-summaries')
  return response.data.data
}
